import {
  InteractionStepType,
  InteractionStepConfig,
  StepParamsForType,
} from '@scale/shared/types/chat';
import { INamedEntityRecognitionResponseAnnotationSchema } from '@scale/shared/types/response/namedentityrecognition';
import { IMultiTurnThreadHistory } from '../../ThreadHistory.interface';

import NamedEntityRecognitionViewComponent from './NamedEntityRecognitionViewComponent';
import NamedEntityRecognitionPinnedViewComponent from './NamedEntityRecognitionPinnedViewComponent';

import NamedEntityRecognitionConfigurationComponent from './NamedEntityRecognitionConfigurationComponent';
import StepDescriptor from '../stepDescriptor/StepDescriptor';

import { schema } from './validation';
import { registerStepDescriptor } from '../stepDescriptor/stepDescriptorContainer';

export class NamedEntityRecognitionStepDescriptor extends StepDescriptor<InteractionStepType.NER> {
  type = InteractionStepType.NER;
  title = InteractionStepConfig[InteractionStepType.NER].title;
  description = InteractionStepConfig[InteractionStepType.NER].description;

  ViewComponent = NamedEntityRecognitionViewComponent;
  PinneDViewComponent = NamedEntityRecognitionPinnedViewComponent;

  ConfigurationComponent = NamedEntityRecognitionConfigurationComponent;

  validationSchema = schema;

  getResponseTemplatePaths() {
    return [
      {
        path: 'context.response.annotations',
        label: 'NER Annotations',
        expectsArray: true,
        expectedSchema: INamedEntityRecognitionResponseAnnotationSchema,
      },
    ];
  }

  generateEmptyResponse(
    _stepParams: StepParamsForType<InteractionStepType.NER>,
    history: IMultiTurnThreadHistory,
  ) {
    const lastResponse = history.getMostRecentResponse();
    return {
      type: InteractionStepType.NER,
      context: {
        response: {
          annotations: [],
        },
      },
      output: lastResponse,
    };
  }
}

registerStepDescriptor({
  type: InteractionStepType.NER,
  descriptor: new NamedEntityRecognitionStepDescriptor(),
});
